import { Icon } from "@iconify/react";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * A component that renders a vehicle card in the home page
 *
 * @param {Object} props
 * @param {{name: string, short_name: string, image: string, seats: number, luggage: number, driver: boolean, tracking_system: boolean, security_camera: boolean, wifi: boolean }} props.veichel - The vehicle data for the card
 * @returns {JSX.Element}
 */

const VeichelTypeCard = ({ veichel }) => {
  const [t] = useTranslation("global");
  return (
    <div
      dir={document.documentElement.dir}
      className="flex-1 px-6 h-full py-10 mr-4 bg-background_grey rounded-lg transition-all duration-300 group hover:text-text_white hover:bg-hover_steel_blue"
    >
      <p className="font-bold text-[#E9B838c6] group-hover:text-text_white text-lg">
        {veichel.name}
      </p>
      <p className="text-gray-200 text-sm group-hover:text-text_white">
        {veichel.short_name}
      </p>
      <img
        className="w-52 h-28 m-auto"
        src={veichel.image}
        alt={veichel.name}
      />
      <div className="grid-cols-2 grid gap-6 pt-3 text-sm font-semibold justify-between border-t border-text_black ">
        <div className="flex gap-2 items-center">
          <Icon
            icon="mdi:user"
            className="w-5 h-5 text-text_steel_blue group-hover:text-text_white"
          />
          <p className="group-hover:text-text_white">
            {veichel.seats} {t("vehicle_type.vehicle_data.available_text")}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <Icon
            icon="iconamoon:shopping-bag-thin"
            className="w-5 h-5 text-text_steel_blue group-hover:text-text_white"
          />
          <p className="group-hover:text-text_white">
            {veichel.luggage} {t("vehicle_type.vehicle_data.luggage_text")}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <Icon
            icon="healthicons:truck-driver"
            className="w-5 h-5 text-text_steel_blue group-hover:text-text_white"
          />
          <p className="group-hover:text-text_white">
            {veichel.driver
              ? t("vehicle_type.vehicle_data.driver_text")
              : t("vehicle_type.vehicle_data.no_driver_text")}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <Icon
            icon="ph:security-camera-thin"
            className="w-5 h-5 text-text_steel_blue group-hover:text-text_white"
          />
          <p className="group-hover:text-text_white">
            {veichel.security_camera
              ? t("vehicle_type.vehicle_data.security_text")
              : t("vehicle_type.vehicle_data.no_security_text")}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <Icon
            icon="streamline:navigation-arrow-on"
            className="w-5 h-5 text-text_steel_blue group-hover:text-text_white"
          />
          <p className="group-hover:text-text_white">
            {veichel.tracking_system
              ? t("vehicle_type.vehicle_data.tracking_text")
              : t("vehicle_type.vehicle_data.no_tracking_text")}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <Icon
            icon="material-symbols:wifi-sharp"
            className="w-5 h-5 text-text_steel_blue group-hover:text-text_white"
          />
          <p className="group-hover:text-text_white">
            {veichel.wifi
              ? t("vehicle_type.vehicle_data.wifi_text")
              : t("vehicle_type.vehicle_data.no_wifi_text")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VeichelTypeCard;
